module.exports = _;


//////////////////
// WEBPACK FOOTER
// external "_"
// module id = 4
// module chunks = 0 1 2 3